module.exports = __webpack_public_path__ + "img/border_leftTriangle.32d8ae1e.svg";